import { hydrateRoot } from "react-dom/client";
import { Home } from "./home";

const root = document.getElementById("root");

if (root) {
  hydrateRoot(root, <Home />);
}
